"use client";

import { FC, ReactNode, useState } from "react";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
import { CustomLink } from "@/types";

interface AccordionProps {
  title: ReactNode;
  content: ReactNode;
  defaultOpen?: boolean;
  openIcon: ReactNode;
  closedIcon: ReactNode;
  customClassName?: string;
  customClassNameOpen?: string;
  cta?: CustomLink;
}

const AccordionV2: FC<AccordionProps> = ({
  title,
  content,
  defaultOpen = false,
  openIcon,
  closedIcon,
  customClassName,
  customClassNameOpen,
  cta,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(defaultOpen);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {!content && cta ? (
        <div className={`md:flex md:items-center px-4 pb-m md:pb-0  cursor-pointer w-full ${customClassName ? customClassName : ""}`}>
          {title}

          <Button
            href={cta.link.url}
            size={ButtonSize.MEDIUM}
            variant={ButtonVariant.TERTIARY}
            theme={ButtonTheme.BLACK}
            customClass="p-0 md:px-m font-medium underline-offset-4"
          >
            {cta.label}
          </Button>
        </div>
      ) : (
        <>
          <button
            className={`flex justify-between items-center px-4 py-2 cursor-pointer w-full text-left ${customClassName ? customClassName : ""} ${isOpen ? customClassNameOpen : ""}`}
            onClick={toggleAccordion}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                toggleAccordion();
              }
            }}
          >
            {title}
            {isOpen ? openIcon : closedIcon}
          </button>

          {isOpen && <div className="pb-l font-secondary-light">{content}</div>}
        </>
      )}
    </>
  );
};

export default AccordionV2;
